<template>
  <div>
    <div class="px-3">
      <div class="row">
        <div class="col-12" v-for="q in questionnaire" :key="q.id">
          <section-title
            container-class=" mt-2 mb-2 "
            :content="q.name"
            v-if="showSectionName(q.name)"
          />
          <div class="row">
            <div
              v-for="(item, key) in q.questions"
              :key="key"
              class="col-12"
              :class="{
                'col-lg-12':
                  isVerbalizeQuestion(item.id) || isCol4CheckQuestion(item.id),
                'col-lg-6':
                  !isVerbalizeQuestion(item.id) &&
                  !isCol4CheckQuestion(item.id),
              }"
            >
              <div
                class="col my-3 pr-1"
                :class="isQuestionRadio(item.mode) && 'border-bottom'"
              >
                <validation-provider v-slot="{ errors }" rules="required">
                  <div class="row mb-3 mb-md-0">
                    <div
                      class="d-flex align-items-center"
                      :class="{
                        'col-sm': isQuestionRadio(item.mode),
                        'col-12 font-weight-bold': !isQuestionRadio(item.mode),
                      }"
                    >
                      {{ item.text }}
                    </div>
                    <template v-if="isQuestionRadio(item.mode)">
                      <div class=" d-flex justify-content-end pr-0">
                        <custom-radio
                          is-question-list
                          class="radio-button-container"
                          v-model="item.answer"
                          :key="item.id"
                          :options="yesNoOptions(item)"
                          :disabled="isReadOnly"
                          :custom-error-msg="''"
                          @input="onQuestionChange($event, item)"
                        />
                      </div>
                      <div class="col-12" v-if="Boolean(errors[0])">
                        <error
                          variant="no-border"
                          message="Favor de seleccionar una opción."
                        />
                      </div>
                    </template>
                    <template v-if="!isQuestionRadio(item.mode)">
                      <div
                        class="col-12 d-flex justify-content-end pr-0"
                        :class="{
                          'col-lg-4': isCol4CheckQuestion(item.id),
                        }"
                        v-for="answer in item.answers"
                        :key="answer.id"
                      >
                        <checkbox
                          class="my-2"
                          :disabled-bg-color="'bg-dark-gray'"
                          :checked-bg-color="'bg-success'"
                          :icon="'fal fa-check'"
                          :text="answer.text"
                          v-model="answer.isSelected"
                          :disabled="isReadOnly"
                          @input="onQuestionChange($event, item, answer)"
                        />
                      </div>
                      <div class="col-12">
                        <validation-provider
                          v-slot="{ errors }"
                          :rules="
                            !item.answers.some((p) => p.isSelected)
                              ? 'required'
                              : ''
                          "
                        >
                          <error
                            v-if="errors[0]"
                            :message="'Favor seleccionar al menos una opción.'"
                            variant="no-border"
                          />
                        </validation-provider>
                      </div>
                    </template>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div
              v-if="isReadingSkill"
              class="col-md-12 col-xs-12 col-sm-12 col-lg-6"
            >
              <div class="row px-3">
                <div class="col-md-6 ">
                  <label
                    class="color-secondary-6 font-weight-normal mr-2 font-16"
                  >
                    Palabras por minuto:
                  </label>
                </div>
                <div class="col-md-6">
                  <validation-provider
                    :rules="'required|numberNa'"
                    v-slot="{ errors, failedRules }"
                  >
                    <custom-input
                      v-model="model.additionalRemarks.wordsPerMinutes"
                      class="mb-2"
                      type="text"
                      :error="errors[0]"
                      :custom-error-msg="
                        failedRules['required']
                          ? 'Este campo es requerido'
                          : errors[0]
                      "
                      :maxlength="'8'"
                      :disabled="isReadOnly"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div v-if="isSensorySkill" class="col-12">
              <div v-if="isVision(q.id)">
                <label
                  class="color-secondary-6 font-weight-normal mr-2 font-16"
                >
                  Diagnósticos identificados en evaluación oftamológica (si
                  aplica):
                </label>
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-text-area
                    v-model="model.additionalRemarks.ophthalmologicEvaluation"
                    class="mb-2"
                    :count-classes="['d-block text-right']"
                    custom-error-msg="Este campo es requerido"
                    :error="errors[0] ? 'err' : ''"
                    :maxlength="3000"
                    :show-char-count="true"
                    placeholder="Comentario"
                    :disabled="isReadOnly"
                  />
                </validation-provider>
              </div>

              <div v-if="isAudition(q.id)">
                <label
                  class="color-secondary-6 font-weight-normal mr-2 font-16"
                >
                  Observaciones importantes en esta área:
                </label>
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-text-area
                    v-model="model.additionalRemarks.importObservations"
                    class="mb-2"
                    :count-classes="['d-block text-right']"
                    custom-error-msg="Este campo es requerido"
                    :error="errors[0] ? 'err' : ''"
                    :maxlength="3000"
                    :show-char-count="true"
                    placeholder="Comentario"
                    :disabled="isReadOnly"
                  />
                </validation-provider>
              </div>

              <div v-if="isAudition(q.id)">
                <label
                  class="color-secondary-6 font-weight-normal mr-2 font-16"
                >
                  Resultados de evaluación audiológica (si aplica):
                </label>
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-text-area
                    v-model="
                      model.additionalRemarks.resultOfEvaluationAudiological
                    "
                    class="mb-2"
                    :count-classes="['d-block text-right']"
                    custom-error-msg="Este campo es requerido"
                    :error="errors[0] ? 'err' : ''"
                    :maxlength="3000"
                    :show-char-count="true"
                    placeholder="Comentario"
                    :disabled="isReadOnly"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isMathSkill" class="col-12">
          <div>
            <label class="color-secondary-6 font-weight-normal mr-2 font-16">
              Observaciones adicionales:
            </label>
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              v-model="model.additionalRemarks.mathAdditionalObservation"
              class="mb-2"
              :count-classes="['d-block text-right']"
              custom-error-msg="Este campo es requerido"
              :error="errors[0] ? 'err' : ''"
              :maxlength="3000"
              :show-char-count="true"
              placeholder="Comentario"
              :disabled="isReadOnly"
            />
          </validation-provider>
        </div>
        <div v-if="isComunicationSkill" class="col-12">
          <div>
            <label class="color-secondary-6 font-weight-normal mr-2 font-16">
              Observaciones adicionales:
            </label>
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              v-model="model.additionalRemarks.comuniAdditionalObservation"
              class="mb-2"
              :count-classes="['d-block text-right']"
              custom-error-msg="Este campo es requerido"
              :error="errors[0] ? 'err' : ''"
              :maxlength="3000"
              :show-char-count="true"
              placeholder="Comentario"
              :disabled="isReadOnly"
            />
          </validation-provider>
        </div>
        <div v-if="isCognitiveSkill" class="col-12">
          <div>
            <label class="color-secondary-6 font-weight-normal mr-2 font-16">
              Observaciones adicionales:
            </label>
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              v-model="model.additionalRemarks.cognitiveAdditionalObservation"
              class="mb-2"
              :count-classes="['d-block text-right']"
              custom-error-msg="Este campo es requerido"
              :error="errors[0] ? 'err' : ''"
              :maxlength="3000"
              :show-char-count="true"
              placeholder="Comentario"
              :disabled="isReadOnly"
            />
          </validation-provider>
        </div>
        <div v-if="isReadingSkill" class="col-12">
          <div>
            <label class="color-secondary-6 font-weight-normal mr-2 font-16">
              Observaciones adicionales:
            </label>
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              v-model="model.additionalRemarks.lectureAdditionalObservation"
              class="mb-2"
              :count-classes="['d-block text-right']"
              custom-error-msg="Este campo es requerido"
              :error="errors[0] ? 'err' : ''"
              :maxlength="3000"
              :show-char-count="true"
              placeholder="Comentario"
              :disabled="isReadOnly"
            />
          </validation-provider>
        </div>
        <div v-if="isMotoSkill" class="col-12">
          <div>
            <label class="color-secondary-6 font-weight-normal mr-2 font-16">
              Observaciones adicionales:
            </label>
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              v-model="model.additionalRemarks.motoAdditionalObservation"
              class="mb-2"
              :count-classes="['d-block text-right']"
              custom-error-msg="Este campo es requerido"
              :error="errors[0] ? 'err' : ''"
              :maxlength="3000"
              :show-char-count="true"
              placeholder="Comentario"
              :disabled="isReadOnly"
            />
          </validation-provider>
        </div>
        <div v-if="isOwnCareSkill" class="col-12">
          <div>
            <label class="color-secondary-6 font-weight-normal mr-2 font-16">
              Observaciones adicionales:
            </label>
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              v-model="model.additionalRemarks.ownCareAdditionalObservation"
              class="mb-2"
              :count-classes="['d-block text-right']"
              custom-error-msg="Este campo es requerido"
              :error="errors[0] ? 'err' : ''"
              :maxlength="3000"
              :show-char-count="true"
              placeholder="Comentario"
              :disabled="isReadOnly"
            />
          </validation-provider>
        </div>
        <div v-if="isWriteSkill" class="col-12">
          <div>
            <label class="color-secondary-6 font-weight-normal mr-2 font-16">
              Observaciones adicionales:
            </label>
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              v-model="model.additionalRemarks.writeAdditionalObservation"
              class="mb-2"
              :count-classes="['d-block text-right']"
              custom-error-msg="Este campo es requerido"
              :error="errors[0] ? 'err' : ''"
              :maxlength="3000"
              :show-char-count="true"
              placeholder="Comentario"
              :disabled="isReadOnly"
            />
          </validation-provider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from 'CheckBox';
import CustomRadio from '@/components/common/CustomRadioBorder';
import CustomTextArea from '@quisit/custom-text-area';
import SectionTitle from 'SectionTitle';
import questionAnswerMode from '@/utils/constants/questionAnswerMode';
import CustomInput from 'CustomInput';
import Error from 'custom-error';
const skills = Object.freeze({
  SENSORY: 2,
  WRITINGSKILLS: 7,
  COMUNICATION: 8,
  COGNITIVE: 3,
  READING: 4,
  MOTO: 6,
  MATH: 5,
  SELFCARESKILLS: 9,
});

const VERBALIZE_QUESTION_ID = 148;
const HISTYPINGIS = 132;
const WRITTENTASKS = 133;
const NOT_APPLY_ANSWER_ID = 137;
const AREAS = Object.freeze({ VISION: 19, AUDITION: 20 });
export default {
  name: 'ItemSkills',
  components: {
    Checkbox,
    CustomRadio,
    CustomTextArea,
    SectionTitle,
    CustomInput,
    Error,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        questions: [],
        additionalRemarks: {
          comuniAdditionalObservation: null,
          importObservations: null,
          resultOfEvaluationAudiological: null,
          ophthalmologicEvaluation: null,
          cognitiveAdditionalObservation: null,
          wordsPerMinutes: null,
          lectureAdditionalObservation: null,
          motoAdditionalObservation: null,
          mathAdditionalObservation: null,
          writeAdditionalObservation: null,
        },
      }),
    },
    questionnaire: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      default: () => '',
    },
    skillId: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      additionalRemarks: '',
    };
  },
  computed: {
    questions() {
      return this.questionnaire.length ? this.questionnaire[0].questions : [];
    },
    isQuestionRadio() {
      const multiChoiceQuestionId = [
        questionAnswerMode.SeleccionMultiple,
        questionAnswerMode.SeleccionMultipleHijos,
      ];
      return (mode) => !multiChoiceQuestionId.includes(mode);
    },
    isVerbalizeQuestion() {
      return (questionId) => VERBALIZE_QUESTION_ID == questionId;
    },
    isCol4CheckQuestion() {
      return (questionId) =>
        HISTYPINGIS == questionId || WRITTENTASKS == questionId;
    },
    yesNoOptions() {
      return (question) => {
        const { answer, answers, id } = question;

        const answersSaved = this.model.questions.find(
          (x) => x.questionId === id
        );

        if (answersSaved) {
          const r = answers.map((x) => ({
            label: x.text == 'No Aplica' ? 'N/A' : x.text,
            value: x.id,
            check: false,
          }));

          for (let i = 0; i < r.length; i++) {
            const element = r[i];
            const checked = answersSaved.answerId == element.value;
            if (checked) {
              element.check = true;
            }
          }

          return r;
        }

        const result = answers.map((x) => ({
          label: x.text == 'No Aplica' ? 'N/A' : x.text,
          value: x.id,
          check: x.isSelected,
        }));

        return result;
      };
    },
    showSectionName() {
      return (name) => this.title !== name;
    },
    isWriteSkill() {
      return this.skillId === skills.WRITINGSKILLS;
    },
    isSensorySkill() {
      return this.skillId === skills.SENSORY;
    },
    isComunicationSkill() {
      return this.skillId === skills.COMUNICATION;
    },
    isCognitiveSkill() {
      return this.skillId === skills.COGNITIVE;
    },
    isReadingSkill() {
      return this.skillId === skills.READING;
    },
    isMotoSkill() {
      return this.skillId === skills.MOTO;
    },
    isMathSkill() {
      return this.skillId === skills.MATH;
    },
    isOwnCareSkill() {
      return this.skillId === skills.SELFCARESKILLS;
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    isVision(id) {
      return id == AREAS.VISION;
    },
    isAudition(id) {
      return id == AREAS.AUDITION;
    },

    onQuestionChange(value, question, answer) {
      if (!this.isQuestionRadio(question.mode) && value) {
        if (answer && answer.id == NOT_APPLY_ANSWER_ID) {
          question.answers
            .filter((x) => x.id !== NOT_APPLY_ANSWER_ID)
            .forEach((ans) => {
              ans.isSelected = false;
            });
        } else if (
          question &&
          question.answers.find((x) => x.id === NOT_APPLY_ANSWER_ID)?.isSelected
        ) {
          question.answers.find(
            (x) => x.id === NOT_APPLY_ANSWER_ID
          ).isSelected = false;
          question.answers.find((x) => x.id === answer.id).isSelected = true;
        }
      }

      const answerId = answer ? answer.id : parseInt(value);

      const index = this.model.questions.findIndex(
        (item) => item.questionId === question.id
      );

      if (index !== -1 && this.isQuestionRadio(question.mode)) {
        this.model.questions[index].answerId = answerId;
        this.$forceUpdate();
        return;
      }

      if (
        index !== -1 &&
        !this.isQuestionRadio(question.mode) &&
        value === false
      ) {
        this.model.questions.splice(index, 1);
        return;
      }

      this.model.questions.push({
        questionId: question.id,
        answerId: answerId,
        skillId: this.skillId,
      });

      this.$forceUpdate();
    },
    handlerAdditionalRemarks(value) {
      const index = this.model.additionalRemarks.findIndex(
        (item) => item.skillId === this.skillId
      );

      if (index !== -1) {
        this.model.additionalRemarks[index].text = value;
        return;
      }

      this.model.additionalRemarks.push({
        text: value,
        skillId: this.skillId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .custom-radio-button {
    width: 100px !important;
  }
}
</style>
